import { Alert as Alert_phosphor } from './Alert.phosphor';
import { Alert as Alert_zoomg } from './Alert.zoomg';
import { Alert as Alert_zoomit } from './Alert.zoomit';

const IconRenderer = () => {
  switch (process.env.NEXT_PUBLIC_ICON_SYSTEM) {
    case 'zoomg':
      return Alert_zoomg;

    case 'phosphor':
      return Alert_phosphor;

    default:
      return Alert_zoomit;
  }
};

export const Alert = IconRenderer();
